/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Scope_Point_2Inputs */

const en_svc_rag_scope_point_2 = /** @type {(inputs: Svc_Rag_Scope_Point_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customer support chatbot on your website or WhatsApp`)
};

const lv_svc_rag_scope_point_2 = /** @type {(inputs: Svc_Rag_Scope_Point_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klientu atbalsta čatbots mājaslapā vai WhatsApp`)
};

/**
* | output |
* | --- |
* | "Customer support chatbot on your website or WhatsApp" |
*
* @param {Svc_Rag_Scope_Point_2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_rag_scope_point_2 = /** @type {((inputs?: Svc_Rag_Scope_Point_2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Scope_Point_2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_rag_scope_point_2(inputs)
	return en_svc_rag_scope_point_2(inputs)
});